import { AGENT_STATE } from '@/constants/agent/constants';
import EcsBusinessProcessContact from '@/classes/contacts/EcsBusinessProcessContact';

const addCrmContact = (state, newContact) => {
  const contactIndex = state.CRM_CONTACTS.findIndex(contact => contact.id === newContact.id);
  if (contactIndex !== -1) {
    // Update stored contact.
    Object.assign(state.CRM_CONTACTS[contactIndex], newContact);
  } else {
    // Store as new contact.
    state.CRM_CONTACTS.push(newContact);
  }
};

const addCrmTemplate = (state, { contactId, businessProcessId, data }) => {
  const templateIndex = state.CRM_TEMPLATES.findIndex(
    contact => contact.contactId === contactId && contact.businessProcessId === businessProcessId
  );

  if (templateIndex !== -1) {
    // Update stored template.
    Object.assign(state.CRM_TEMPLATES[templateIndex].data, data);
  } else {
    // Store as new template.
    state.CRM_TEMPLATES.push({ contactId, businessProcessId, data, dateTime: Date.now() });
  }
};

const updateCrmContact = (state, data) => {
  const contactIndex = state.CRM_CONTACTS.findIndex(elem => elem.id === data.contactId);

  if (contactIndex === -1) {
    return;
  }
  const contact = state.CRM_CONTACTS[contactIndex];
  state.CRM_CONTACTS.splice(contactIndex, 1, { ...contact, ...data.properties });
};

const removeCrmContacts = (state, contactIds) => {
  if (contactIds.length) {
    contactIds.forEach(contactId => {
      const contactIndex = state.CRM_CONTACTS.findIndex(contact => contact.id === contactId);

      if (contactIndex === -1) {
        return;
      }
      state.CRM_CONTACTS.splice(contactIndex, 1);
    });
  }
};

const setContacts = (state, contacts) => {
  state.AGENTS = contacts.agents
    ? contacts.agents
        .sort(EcsBusinessProcessContact.compare)
        .map(agent => ({ ...agent, state: { id: '', name: 'Offline' } }))
    : [];

  state.SUPERVISORS = contacts.supervisors
    ? contacts.supervisors
        .sort(EcsBusinessProcessContact.compare)
        .map(supervisor => ({ ...supervisor, state: { id: '', name: 'Offline' } }))
    : [];

  state.BUSINESS_PROCESSES = contacts.businessProcesses
    ? contacts.businessProcesses
        .sort(EcsBusinessProcessContact.compare)
        .map(contact => new EcsBusinessProcessContact(contact))
    : [];

  state.CHANNELS = contacts.channels ? contacts.channels.sort(EcsBusinessProcessContact.compare) : [];
};

const setFavoriteContacts = (state, favorites) => {
  state.FAVORITES = favorites;
};

const setCompanyContacts = (state, { contacts, getters }) => {
  state.ENTERPRISE = contacts.enterprise ? contacts.enterprise : [];
  const statesMap = {};
  getters['REFERENCES/availableAgentStates'].forEach(state => {
    statesMap[state.name] = state.id;
  });

  state.ENTERPRISE.filter(contact => contact.presence).forEach(contact => {
    const stateId = statesMap[contact.presence] ? statesMap[contact.presence] : AGENT_STATE.offline;
    state.STATES[contact.id] = { stateName: contact.presence, stateId };
  });
};

const setExternalContacts = (state, contacts) => {
  state.EXTERNAL = contacts.external ? contacts.external : [];
};

const updateAvailabilityState = (state, payload) => {
  const { stateId, stateName, ...rest } = payload;

  state.STATES = {
    ...structuredClone(state.STATES),
    [payload.agentId || payload.userId]: { stateId, stateName, ...rest }
  };
};

export default {
  addCrmContact,
  addCrmTemplate,
  updateCrmContact,
  removeCrmContacts,
  setContacts,
  setCompanyContacts,
  setFavoriteContacts,
  setExternalContacts,

  updateAvailabilityState
};
